import { render, staticRenderFns } from "./confirm-action.vue?vue&type=template&id=4009ad64"
import script from "./confirm-action.vue?vue&type=script&lang=js"
export * from "./confirm-action.vue?vue&type=script&lang=js"
import style0 from "./confirm-action.vue?vue&type=style&index=0&id=4009ad64&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports